// extracted by mini-css-extract-plugin
export var box = "_3r-0";
export var check = "_3r-1";
export var checkboxButton = "_3r-6";
export var checkboxGroup = "_3r-5";
export var disabled = "_3r-7";
export var ghost = "_3r-9";
export var input = "_3r-2";
export var label = "_3r-4";
export var normal = "_3r-8";
export var uncheck = "_3r-3";